export {};

declare global {
  /**
   * 配列の拡張関数群
   */
  interface Array<T> {
    isEmpty(): boolean;
    filterNotNull(): Array<T>;
  }
}

/**
 * 配列の中身が空かどうかを判定する関数
 * @returns - 空ならtrue、そうでなければfalse
 * @example
 * const arr = [];
 * console.log(arr.isEmpty()); // true
 * const arr2 = [1, 2, 3];
 * console.log(arr2.isEmpty()); // false
 * const arr3 = [undefined];
 * console.log(arr3.isEmpty()); // false
 * const arr4 = [null];
 * console.log(arr4.isEmpty()); // false
 */
Array.prototype.isEmpty = function (): boolean {
  return this.length === 0;
};

/**
 * 配列の中身にnullが含まれている場合、nullを除外して返却する関数
 * @returns - nullを除外した配列
 * @example
 * const arr = [1, 2, null, 3];
 * console.log(arr.filterNotNull()); // [1, 2, 3]
 * const arr2 = [null, null, null];
 * console.log(arr2.filterNotNull()); // []
 * const arr3 = [1, 2, 3];
 * console.log(arr3.filterNotNull()); // [1, 2, 3]
 * const arr4 = [];
 * console.log(arr4.filterNotNull()); // []
 * const arr5 = [undefined, null];
 * console.log(arr5.filterNotNull()); // []
 */
Array.prototype.filterNotNull = function <T>(this: Array<T>): Array<NonNullable<T>> {
  return this.filter((item): item is NonNullable<T> => item !== null && item !== undefined);
};
